import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import history from '../../../../../history';

const FairCartButton = ({ cartCount, onMailClick, isMailLoading }) => {
    const handleCartClick = () => {
        history.push('/cart');
    };

    return (
        <div className="fair-cart-button">
            <button
                type="button"
                className="fair-cart-button__cart"
                onClick={handleCartClick}
            >
                <FormattedMessage
                    id="fair.cart_button.cart"
                    values={{ count: cartCount || 0 }}
                />
            </button>
            <button
                type="button"
                className="fair-cart-button__mail"
                onClick={onMailClick}
                disabled={isMailLoading || !cartCount}
            >
                <FormattedMessage id="fair.cart_button.mail" />
            </button>
        </div>
    );
};

FairCartButton.propTypes = {
    cartCount: PropTypes.number,
    onMailClick: PropTypes.func,
    isMailLoading: PropTypes.bool,
};

FairCartButton.defaultProps = {
    cartCount: 0,
    isMailLoading: false,
};

export default FairCartButton;
